import React, { useState } from "react";
import { Alert, Button, Paper, TextField } from "@mui/material";
import { Grid } from "@material-ui/core";

const PlaceStopLoss = ({ user }) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [message, setMessage] = useState('');
    const [slUser, setSLUser] = useState('');

    const handleChange = (event) => {
        setSLUser(event.target.value);
    };

    const placeStopLoss = (event) => {
        console.log("Place Stop Loss");
        setErrorMessage('')

        function handleResponse(response) {
            response.text().then(r => {
                if (response.ok) {
                    console.log('OK', r)
                    setMessage('Stop Loss Placed')
                } else {
                    setErrorMessage(r)
                    console.log('FAIL', r)
                }
            })
        }

        fetch(`/algo-trading/api/admin/order/stop-loss?userId=${encodeURIComponent(slUser)}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                'Authorization': user.credential,
            }
        }).then(function (response) {
            handleResponse(response);
        }, function (error) {
            setErrorMessage(error.message)
            console.log('ERROR', error.message)
        })

        /*fetch('/algo-trading/api/admin/order/manual-stop-loss', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                'Authorization': user.credential,
            }
        }).then(function (response) {
            handleResponse(response);
        }, function (error) {
            setErrorMessage(error.message)
            console.log('ERROR',error.message)
        })*/
    }

    return (
        <>
            <Grid container lg={4} md={5} sm={8} xs={12} component={Paper} spacing={1} >
                <Grid container>
                    <Grid container>
                        {message && (<Alert variant={"filled"} severity="success">{message}</Alert>)}
                    </Grid>
                    <Grid container>
                        {errorMessage && (<Alert variant={"filled"} severity="warning">{errorMessage}</Alert>)}
                    </Grid>
                </Grid>
                <Grid item>
                    <TextField label='User id for Stop Loss'
                        size="small"
                        onChange={event => handleChange(event)}
                        value={slUser} />
                </Grid>
                <Grid item>
                    <Button variant="contained" color="primary" onClick={event => placeStopLoss(event)}>Place Stop Loss</Button>
                </Grid>
            </Grid>
        </>
    );
}


export default PlaceStopLoss